var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-file',{attrs:{"disabled":_vm.disabled,"state":_vm.state,"placeholder":_vm.placeholder,"browse-text":_vm.browseText,"accept":"image/*","multiple":_vm.multiple,"capture":_vm.capture},on:{"change":_vm.onChange},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }